import type { Action } from 'react-sweet-state';
import { createStore, createStateHook, createActionsHook } from 'react-sweet-state';

type State = {
	isOpen: boolean;
	openFrom: string;
};

const initialState: State = {
	isOpen: false,
	openFrom: '',
};

const actions = {
	setIsOpen:
		(isOpen: boolean): Action<State> =>
		({ setState }) => {
			setState({
				isOpen,
			});
		},
	setOpenFrom:
		(openFrom: string): Action<State> =>
		({ setState }) => {
			setState({ openFrom });
		},
};

const Store = createStore({
	initialState,
	actions,
	name: 'UniversalCreateStore',
});

export const useUniversalCreateState = createStateHook(Store);
export const useUniversalCreateActions = createActionsHook(Store);
